/** This enum file contains common enums used across multiple entities or entities that only
 * contain a couple enums
 *
 * If any changes are made it will reflect across multiple objects rather than having to
 * change the enum for each object
 */
export enum Sport {
    SOCCER = "SOCCER",
    BASKETBALL = "BASKETBALL",
    FLAGFOOTBALL = "FLAGFOOTBALL",
}

export enum OrganizationStatus {
    APPROVED = "APPROVED",
    REGISTERED = "REGISTERED",
    CLOSING = "CLOSING",
    DISABLED = "DISABLED",
}

export enum Day {
    Sunday,
    Monday,
    Tuesday,
    Wednesday,
    Thursday,
    Friday,
    Saturday,
}
